var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandImageSentiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 6 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3.5,
    r: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.75L3.75 4.25M5.25 5.75V4.55M5.25 5.75H4.05M0.75 4.55V5.75M0.75 5.75H1.95M0.75 5.75L2.25 4.25M5.25 2.45V1.25M5.25 1.25H4.05M5.25 1.25L3.75 2.75M0.75 2.45V1.25M0.75 1.25H1.95M0.75 1.25L2.25 2.75",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandImageSentiment);
export default __webpack_public_path__ + "static/media/expandImageSentiment.7ca2536fc6c65827e4f4452f2c11a426.svg";
export { ForwardRef as ReactComponent };